import constants from "common/constants";

import logo from "./media/healo-logo.svg";
import bgVideo from "modules/assets/bg/Home.mp4";

import EN_TRANSLATION from "modules/brand/brands/default/messages/en";
import SV_TRANSLATION from "modules/brand/brands/default/messages/sv";

export default {
  name: "healo",
  image: logo,
  imagePost: logo,
  backGroundVideo: bgVideo,
  footerImage: null,
  secondaryBackground: {
    backgroundColor: "rgba(208, 227, 224, 0.9)",
    gradientColors: ["rgba(208, 227, 224, 0.9)", "rgba(208, 227, 224, 0.75)"]
  },
  appBackground: {
    overlayStyle: {
      mixBlendMode: "soft-light",
      backgroundColor: "rgba(208, 227, 224, 0.9)"
    }
  },
  baseClass: "healo",
  domains: [
    "http://localhost:3000",
    "https://dev-osd.healo.app",
    "https://stg-osd.healo.app",
    "https://osd.healo.app"
  ],
  clinicCityEnabled: false,
  clinicId: null,
  ssnEnabled: false,
  anonymousEnabled: true,
  registrationWithEmailEnabled: true,
  registrationWithPhoneEnabled: true,
  emailVerificationEnabled: false,
  additionalSpaceOnRegistrationForm: false,
  homeTitle: "root.title",
  homeDescription: "root.desc",
  translation: {
    [constants.appLanguages.sv]: SV_TRANSLATION,
    [constants.appLanguages.en]: EN_TRANSLATION
  }
};



// WEBPACK FOOTER //
// ./src/modules/brand/brands/healo/settings.js